(exports.GAME_ID = "5fb2b537f6914c0017b8584e"),
(exports.FORM_ID = "5fb2b562f6914c0017b85851"),
(exports.SERVER_URL = "https://api.lucien.ai"),
(exports.BD_NAME = "jeu-Husqvarnav2");